import { Text } from '@hopin-team/ui-text';
import { ToolTip } from '@hopin-team/ui-tool-tip';
import React from 'react';

import { Container, Indicator } from './EventPartTag.styles';

export const GenericTag = ({
  testId,
  icon,
  label,
  indicator,
  indicatorTooltip,
  styling,
}: {
  testId?: string;
  icon?: React.ReactNode;
  label: string;
  indicator?: number;
  indicatorTooltip?: string;
  styling?: {
    backgroundColor?: string;
    textColor?: string;
    px?: number;
    py?: number;
    ml?: number;
    mr?: number;
    height?: number;
  };
}) => (
  <Container
    flexDirection="row"
    alignItems="center"
    data-testid={testId}
    className={testId}
    backgroundColor={styling?.backgroundColor}
    textColor={styling?.textColor}
    px={styling?.px ?? 1}
    py={styling?.py ?? 0}
    ml={styling?.ml ?? 0}
    mr={styling?.mr ?? 0}
    height={styling?.height ?? 3}
  >
    {icon}
    <Text pl={icon ? 1 : 0}>{label}</Text>

    {indicator &&
      (indicatorTooltip ? (
        <ToolTip tip={indicatorTooltip} align="top">
          <Indicator ml={1} backgroundColor={styling?.textColor}>
            {indicator}
          </Indicator>
        </ToolTip>
      ) : (
        <Indicator ml={1} backgroundColor={styling?.textColor}>
          {indicator}
        </Indicator>
      ))}
  </Container>
);
